module.exports = __webpack_public_path__ + "media/images/black_history_month/promo02-0071ebb2d6151acef5fe7fa6689fbbbc.png";